export default __webpack_public_path__ + "static/media/no_maintenance_icon.efa987a8.svg";